import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import paginator from 'services/paginator/paginator'
import PaginatorControls from 'components/util/PaginatorControls'
import * as userSelectors from 'services/user/selectors'
import * as routeActions from 'services/routes/actions'
import styles from './_myBookmarksPage.css'
import MyRoutesHeader from './MyRoutesHeader'
import MyRouteResults from './MyRouteResults'
import ConfirmModal from 'components/util/ConfirmModal'

const paginatorOptions = {
  name: 'myBookmarksPage',
  perPage: 10,
  maxPageButtons: 3,
}

const mapStateToProps = (state) => ({
  userId: userSelectors.selectUserId(state),
})

const mapDispatchToActions = { ...routeActions }

export class MyBookmarksPage extends Component {
  static propTypes = {
    userId: PropTypes.number,
    loadMyRoutesPage: PropTypes.func,
    paginator: PropTypes.object,
    getBookmarkedRoutes: PropTypes.func,
    deleteRouteBookmark: PropTypes.func,
  }

  state = {
    bookmarkIdToDelete: null,
    confirmRemoveBookmark: false,
    deleteRouteBookmarkLoading: false,
  }

  loadPaginatorPage = ({ limit, offset }) => {
    return this.props.getBookmarkedRoutes({
      limit,
      offset,
      userId: this.props.userId,
    })
  }

  handleInitializeDelete = (bookmarkId) => {
    this.setState({
      bookmarkIdToDelete: bookmarkId,
      confirmRemoveBookmark: true,
    })
  }

  onRemoveBookmark = () => {
    const { bookmarkIdToDelete } = this.state
    this.setState({
      deleteRouteBookmarkLoading: true,
    })

    this.props.deleteRouteBookmark(bookmarkIdToDelete).then(() => {
      this.setState({
        confirmRemoveBookmark: false,
      })

      this.props.paginator.loadPage()
    })
  }

  onCancelRemoveBookmark = () => {
    this.setState({
      confirmRemoveBookmark: false,
    })
  }

  render () {
    const {
      paginator: {
        loading,
        results,
      },
    } = this.props

    const {
      confirmRemoveBookmark,
      deleteRouteBookmarkLoading,
    } = this.state

    return (
      <div className={styles.myBookmarksContainer}>
        <MyRoutesHeader />
        <h3 className={styles.myBookmarksTitle}>
          <FormattedMessage
            id='mybookmarks.title'
            defaultMessage='Bookmarked Routes' />
        </h3>
        <MyRouteResults
          routes={results}
          loading={loading}
          removeBookmarkAction={(bookmarkId) => this.handleInitializeDelete(bookmarkId)}
          bookmarkView={true}
          notFoundComponent={
            <FormattedMessage
              id='routesearch.bookmarks.notfound'
              defaultMessage='No Bookmarks Found' />
          } />
        <PaginatorControls {...this.props.paginator} />

        <ConfirmModal
          isOpen={confirmRemoveBookmark}
          isLoading={deleteRouteBookmarkLoading}
          confirmAction={this.onRemoveBookmark}
          cancelAction={this.onCancelRemoveBookmark}
          titleComponent={
            <FormattedMessage id='myroutes.confirmdeletebookmark' defaultMessage='Delete Route Bookmark?' />
          }
        />
      </div>
    )
  }
}

export const Page = paginator(paginatorOptions)(MyBookmarksPage)
export default connect(mapStateToProps, mapDispatchToActions)(Page)
